import { createSelector } from '@reduxjs/toolkit';
import { IMAGE_UPLOAD_STATUS } from './storeTransactionImageSlice';

export const selectTransactionBatches = createSelector(
    [(state) => state.storeTransactionImage],
    (storeTransactionImageSlice) => storeTransactionImageSlice?.batches
);

export const selectTransactionStatuses = createSelector(
    [(state) => state.storeTransactionImage],
    (storeTransactionImageSlice) => storeTransactionImageSlice?.transactionStatuses || {}
);

export const selectQueuedImageKeys = createSelector(
    [(state) => state.storeTransactionImage],
    (storeTransactionImageSlice) => storeTransactionImageSlice?.queuedImageKeys || {}
);

// Macaw status -> browser upload status used by the upload indicator
const MACAW_UPLOAD_STATUS = { UPLOADING: IMAGE_UPLOAD_STATUS.UPLOADING, READY: IMAGE_UPLOAD_STATUS.SAVED, FAILED: IMAGE_UPLOAD_STATUS.FAILED };

/**
 * Backend uploads of Macaw images in the shape of browser upload batches, one per transaction. Only for the upload
 * indicator: nothing can be retried from the browser, and they must not be mixed into `batches` (indexes are used for
 * retry).
 */
export const selectMacawUploadBatches = createSelector([(state) => state.storeTransactionImage?.macawUploads], (macawUploads) =>
    Object.values(macawUploads || {}).map(({ images, ...transaction }) => ({
        ...transaction,
        images: Object.entries(images).map(([id, status]) => ({
            id: Number(id),
            status: MACAW_UPLOAD_STATUS[status] || IMAGE_UPLOAD_STATUS.UPLOADING,
            isFinalFailed: status === 'FAILED',
        })),
    }))
);

// browser uploads (agent snapshots) and backend uploads (Macaw images) together, for the upload indicator
export const selectUploadIndicatorBatches = createSelector([selectTransactionBatches, selectMacawUploadBatches], (batches, macawBatches) => [
    ...(batches || []),
    ...macawBatches,
]);

export const selectDeletingAssetIds = createSelector(
    [(state) => state.storeTransactionImage],
    (storeTransactionImageSlice) => storeTransactionImageSlice?.deletingAssetIds || {}
);
